"use strict";
/**
* Config.ts
* Author: CALIB http://aka.ms/CALIB
* Copyright: Microsoft 2017
*
* ECS global configuration
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Config = /** @class */ (function () {
    function Config() {
    }
    Config.prototype.initialize = function (config) {
        if (this._config) {
            throw 'ECS Configuration already initialized';
        }
        this._config = config;
    };
    Config.prototype.getConfig = function () {
        if (!this._config) {
            throw 'ECS Configuration not yet initialized';
        }
        return this._config;
    };
    Config.prototype.setConfigsToFetch = function (configsToFetch) {
        // Create a new config object since it's fully read-only
        if (!this._config) {
            throw 'ECS Configuration not yet initialized';
        }
        this._config = __assign({}, this._config, { configsToFetch: configsToFetch });
    };
    Config.prototype.setFetchTimeout = function (fetchTimeout) {
        // Create a new config object since it's fully read-only
        if (!this._config) {
            throw 'ECS Configuration not yet initialized';
        }
        this._config = __assign({}, this._config, { fetchTimeout: fetchTimeout });
    };
    return Config;
}());
exports.default = Config;
